import React, { useState } from 'react'
import { getElementHeight } from '../../utils/elementHeight'

const FAQCard = ({question, answer, index}) => {

    const [isOpen, setIsOpen] = useState(false)

    return (
        <>
            <div onClick={()=> setIsOpen(!isOpen)} className={`w-full px-3 md:px-5 lg:px-10 py-3 bg-white rounded-10px cursor-pointer ${isOpen && 'space-y-3 faq-active-shadow'} duration-700`} style={{border: !isOpen && '0.8px solid #F0F0F0'}}>
                <div className="relative flex items-center justify-between w-full space-x-3">
                    <h3 className={`w-4/5 text-base md:text-lg lg:text-xl text-left ${isOpen ? 'text-primary font-medium' : 'text-font_primary font-normal'} font-poppins`}>{question} </h3>
                    <svg className={`absolute right-0 top-2 transition transform duration-300 ease-in-out ${isOpen ? '-rotate-180' : 'rotate-0'} `} width="1em" height="1em" viewBox="0 0 21 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19.3125 1.0791L10.6188 9.78086L1.92505 1.0791" stroke={isOpen ? '#006BFF' : '#8B8B8B'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </div>

                <div className="overflow-hidden transition-all duration-300 ease-in-out" style={{height: isOpen ? getElementHeight(`faq-${index}`) : 0}}>
                    <div id={`faq-${index}`} className="w-full py-2 text-sm font-normal leading-7 text-left lg:text-base text-secondary font-roboto">{answer}</div>
                </div>
            </div>
        </>
    )
}

export default FAQCard
